import jsPDF from 'jspdf';
import logo from '../../../../../../../style/img/logo_acciona.png';
import AccionaRegular from '../../../../../../../style/fonts/acciona-regular-normal';
import AccionaBold from '../../../../../../../style/fonts/acciona-medium-bold';
require('jspdf-autotable');

const cellStyle = {
  fillColor: 'rgb(230, 230, 230)',
  cellPadding: 4,
  halign: 'center',
  fontSize: 11,
  valign: 'middle',
  lineWidth: 1,
  lineColor: 'black',
  fontStyle: 'bold',
  font: 'AccionaBold',
};

const tableCellStyle = {
  fillColor: 'white',
  cellPadding: 4,
  halign: 'center',
  textColor: '#666666',
  fontSize: 10,
  valign: 'middle',
  lineWidth: 1,
  lineColor: 'black',
  font: 'AccionaRegular',
};

const nullValue = (value) => {
  if (value === null || value === 'null') {
    return 'Valor no registrado';
  } else {
    return value;
  }
};

const strengthParser = (state) => {
  const csRegex = new RegExp(/^compressive_strength_(\d*)_(\d)/);
  const strengthArray = [];
  if (Object.keys(state).length) {
    [3, 7, 28, 60].forEach((day) => {
      [1, 2, 3].forEach((n) => {
        if (state[`compressive_strength_${day}_${n}`]) {
          strengthArray.push({
            day: day,
            number: n,
            value: state[`compressive_strength_${day}_${n}`],
          });
        }
      });
    });
    if (Object.keys(state.strength_extra).length)
      Object.keys(state.strength_extra).forEach((key) => {
        if (!key.includes('ave')) {
          const [, day, n] = csRegex.exec(key);
          if (state.strength_extra[key]) {
            strengthArray.push({
              day: day,
              number: n,
              value: state.strength_extra[key],
            });
          }
        }
      });
  }
  return strengthArray;
};

const showPageStatus = (doc) => {
  const currentPageInfo = doc.getCurrentPageInfo();
  doc.setFontSize(12);
  doc.text(`${currentPageInfo.pageNumber}/${doc.getNumberOfPages()}`, 400, 600);
};

const generatePDF = ({ formState, labImg, deliveryImg, fileName }) => {
  const doc = new jsPDF({
    unit: 'px',
  });
  const width = doc.internal.pageSize.getWidth();
  const height = doc.internal.pageSize.getHeight();

  doc.addFileToVFS('AccionaRegular.ttf', AccionaRegular);
  doc.addFileToVFS('AccionaBold.ttf', AccionaBold);
  doc.addFont('AccionaRegular.ttf', 'AccionaRegular', 'normal');
  doc.addFont('AccionaBold.ttf', 'AccionaBold', 'bold');

  doc.addImage(logo, 'png', 20, 10, 80, 38);
  doc.autoTable({
    body: [
      [{ content: 'Proveedor', colSpan: 6, styles: { ...cellStyle } }],
      [
        {
          content: nullValue(formState.name),
          colSpan: 6,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Nº Teléfono',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Email',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.phone_number),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.email),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Albarán',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Nº referencia',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.docket_number),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.reference_number),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Resultado de los ensayos',
          colSpan: 6,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: 'Edad de la muestra',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Resistencia a compresión [N/mm2]',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      ...strengthParser(formState).map((d) => {
        return [
          {
            content: `${d.day} días muestra nº ${d.number}`,
            colSpan: 3,
            styles: { ...tableCellStyle },
          },
          {
            content: d.value,
            colSpan: 3,
            styles: { ...tableCellStyle },
          },
        ];
      }),
    ],
    margin: { top: 45 },
    useCss: true,
  });
  showPageStatus(doc);

  if (deliveryImg) {
    doc.addPage();
    doc.addImage(logo, 'png', 20, 10, 80, 38);
    doc.addImage(deliveryImg, 'jpeg', 20, 50, width - 40, height - 120);
    showPageStatus(doc);
  }

  if (labImg) {
    doc.addPage();
    doc.addImage(logo, 'png', 20, 10, 80, 38);
    doc.addImage(labImg, 'jpeg', 20, 50, width - 40, height - 120);
    showPageStatus(doc);
  }

  doc.save(fileName + '.pdf');
};

export default generatePDF;
